module.exports = __webpack_public_path__ + "static/founder-1-9e199c523d785e797c456e9960200718.png";